import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=a43a99ce&scoped=true&"
import script from "./NotificationModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=a43a99ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43a99ce",
  null
  
)

export default component.exports